module.exports = __webpack_public_path__ + "img/164w.3d601ed.jpg";